import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { UnitType } from 'app/shared/model/enumerations/unit-type.model';
import { createEntity, getEntity, reset, updateEntity } from './product-specification.reducer';

export const ProductSpecificationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const productSpecificationEntity = useAppSelector(state => state.productSpecification.entity);
  const loading = useAppSelector(state => state.productSpecification.loading);
  const updating = useAppSelector(state => state.productSpecification.updating);
  const updateSuccess = useAppSelector(state => state.productSpecification.updateSuccess);
  const unitTypeValues = Object.keys(UnitType);

  const handleClose = () => {
    navigate('/product-specification');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...productSpecificationEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          unit: 'KWH',
          ...productSpecificationEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.productSpecification.home.createOrEditLabel"
            data-cy="ProductSpecificationCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.productSpecification.home.createOrEditLabel">
              Create or edit a ProductSpecification
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="product-specification-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.productSpecification.name')}
                id="product-specification-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.productSpecification.description')}
                id="product-specification-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.productSpecification.unit')}
                id="product-specification-unit"
                name="unit"
                data-cy="unit"
                type="select"
              >
                {unitTypeValues.map(unitType => (
                  <option value={unitType} key={unitType}>
                    {translate(`crawlerBackendApp.UnitType.${unitType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.productSpecification.validFrom')}
                id="product-specification-validFrom"
                name="validFrom"
                data-cy="validFrom"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.productSpecification.validTo')}
                id="product-specification-validTo"
                name="validTo"
                data-cy="validTo"
                type="date"
              />
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/product-specification"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ProductSpecificationUpdate;
